<template >
    <b-modal no-close-on-backdrop id="detail" class="detail-popup" v-model="showDetailPopup" size="xl" hide-header hide-footer>
        <template v-if="selectedPost && selectedPost.type === 'moment'">
            <div class="moment">
                <img :src="close" class="close" @click="closeModals" />
                <div class="row mt-4 mb-4">
                    <div class="col-lg-6">
                        <img :src="selectedPost.media.url" style="width: 100%" />
                    </div>
                    <div class="col-lg-6">
                        <div class="profile" v-if="selectedPost.author">
                            <div class="profile-picture">
                                <img :src="selectedPost.author.picture" alt="selectedPost.author.name" />
                            </div>
                            <ul class="list-detail">
                                <li class="author-name">{{ selectedPost.author.name }}</li>
                            </ul>
                        </div>
                        <div class="description" v-html="selectedPost.content"></div>
                        <div class="misc">
                            <div class="network-icon">
                                <i :class="`fa fa-${selectedPost.network}`" />
                            </div>
                            <div class="action-buttons">
                                <img :src="ButtonS" class="share-button shareBtn" alt @click="onClickShare" />
                            </div>
                        </div>
                    </div>
                </div>
                <a
                    href="https://www.mekongdeals.com"
                    class="shadow btn btn-find"
                    target="_blank"
                    rel="noopener noreferrer"
                    >FIND DEALS</a
                >
                <div class="sharing-popup" v-if="Sharing == true">
                <button class="close-share" @click="OncloseSharing">X</button>
                <ShareNetwork
                        v-for="network in networks"
                        :network="network.network"
                        :key="network.network"
                        :style="{backgroundColor: network.color}"
                        style="margin: 50px 5px 5px; padding: 5px;"
                        :url="urlToShare"
                        :title="titleToShare"
                        :description="descriptionToShare"
                        :twitterUser="sharing.twitterUser"
                    >
                        <i :class="network.icon"></i>
                        <span>{{ network.name }}</span>
                    </ShareNetwork>
            </div>
                
            </div>
        </template>

        <template no-close-on-backdrop v-if="selectedPost && selectedPost.type === 'story'">
            <div class="story">
                <img :src="close" class="close" @click="closeModals" />
                <div class="row mt-4 mb-4">
                    <div class="col-lg-6">
                        <img :src="selectedPost.mainImageUrl" style="width: 100%" />
                        <div class="list-button list-button-lg align-items-center pt-1">
                            <div class="d-flex justify-content-between align-items-center"> 
                                <div>
                                    <img :src="ButtonS" class="share-button shareBtn" alt @click="onClickShare" />
                                    REPORT
                                    
                                </div>
                                <div>
                                    <a
                                        href="https://www.mekongdeals.com"
                                        class="shadow btn btn-find"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        >FIND DEALS</a
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="profile" v-if="selectedPost.author">
                            <div class="profile-picture">
                                <img
                                    :src="selectedPost.author.picture"
                                    alt="selectedPost.author.screenName"
                                    style="width: 71px"
                                />
                            </div>
                            <ul class="list-detail">
                                <li v-if="selectedPost.author.screenName">{{ selectedPost.author.screenName }}</li>
                                <li v-if="selectedPost.author.shortBio">{{ selectedPost.author.shortBio }}</li>
                                <li v-if="selectedPost.author.country">{{ selectedPost.author.country }}</li>
                            </ul>
                        </div>
                        <div class="description" v-html="selectedPost.shortContent"></div>
                    </div>
                </div>
                <!-- <div class="row mt-4 mb-4" v-if="connectedPosts && connectedPosts.length > 0"> -->
                <div class="row mt-4 mb-4">
                    <h4>Connected Experiences / Tours</h4>
                </div>
            </div>
            <div class="sharing-popup" v-if="Sharing == true">
                <button class="close-share" @click="OncloseSharing">X</button>
                <ShareNetwork
                        v-for="network in networks"
                        :network="network.network"
                        :key="network.network"
                        :style="{backgroundColor: network.color}"
                        style="margin: 50px 5px 5px; padding: 5px 10px; border-radius: 50px;"
                        :url="urlToShare"
                        :title="titleToShare"
                        :description="descriptionToShare"
                        :twitterUser="sharing.twitterUser"
                    >
                        <i :class="network.icon"></i>
                        <span>{{ network.name }}</span>
                    </ShareNetwork>
            </div>
        </template>
    </b-modal>

    


</template>

<script>
import ButtonS from '@/assets/images/button-s.png';
import close from '@/assets/images/close.png';
import porfile from '@/assets/images/profile.png';
import truncate from 'truncate';
import striptags from 'striptags';
// import VueSocialSharing from '@/vue-social-sharing';



export default {
    data() {
        return{
            close: close,
            showDetailPopup: false,
            selectedPost: null,
            post : null,
            ButtonS : ButtonS,
            connectedPosts: [],
            urlToShare: '',
            titleToShare: '',
            descriptionToShare: '',
            Sharing: false,
            porfile: porfile,
            sharing: {
                twitterUser: 'youyuxi'
            },
      networks: [

        { network: 'facebook', icon: 'fa fa-facebook', color: '#1877f2' },
        { network: 'pinterest', icon: 'fa fa-pinterest', color: '#bd081c' },
        { network: 'twitter', icon: 'fa fa-twitter', color: '#1da1f2' },
        { network: 'whatsapp', icon: 'fa fa-whatsapp', color: '#25d366' },
      ]
        }
    },
    props: {
        posts: {
            type: Array,
            default: []
        }
    },
    mounted() {
        const id = this.$route.params.id;
        this.post = this.posts.find(data => data.id == id);
        if (this.post !== undefined) {
            this.selectedPost = this.post
            this.showDetailPopup = true
        }  else{
            console.log("null")
        }
    },
    methods: {
        closeModals() {
            this.showDetailPopup = false;
            this.$router.push('/');
        },
        onClickShare() {
            // console.log('get in');
			if (!this.selectedPost) return;

			const url = `${window.location.protocol}//${window.location.hostname}?open=${this.selectedPost.id}`;
			const title =
				this.selectedPost.type === 'story'
					? this.selectedPost.title
					: truncate(striptags(this.selectedPost.content), 100);
			const text = truncate(striptags(this.selectedPost.content), 200);

			if (navigator.share) {
				navigator.share({
					title,
					text,
					url,
				});
			} else {
                this.titleToShare = title;
                this.descriptionToShare = text;
                this.urlToShare = url;
                this.Sharing = true;
				
			}
        },
        OncloseSharing() {
            this.Sharing = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .detail-popup {
			position: relative;
			display: none;
			height: 100%;
			width: 50%;
			padding: 30px;

			.profile {
				position: absolute;
				bottom: 10px;
				.pic-profile {
					display: flex;

					img {
						max-width: 71px;
						width: 100%;
					}

					.list-detail {
						list-style: none;
						padding: 0 10px;

						li {
							&:first-child {
								font-size: 18px;
								font-weight: bold;
							}

							&:last-child {
								padding-top: 40px;
								font-size: 18px;
								font-weight: bold;
							}
						}
					}
				}
			}
            
		}

        @media screen and (min-width: 992px) {
            .modal-body {
                .profile {
                    margin-top: 20px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .profile-picture {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    overflow: hidden;
                    flex: 0 0 auto;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .list-detail {
                    padding: 0;
                    list-style: none;
                    flex: 1 1 auto;
                    margin-left: 20px;
                }

                .description {
                    margin-top: 20px;
                    font-size: 14px;
                }

                .network-icon {
                    margin-top: 10px;
                    margin-right: 20px;
                    font-size: 1.8rem;
                }

                .action-buttons {
                    margin-top: 20px;
                    margin-left: -6px;
                }

                .btn-find {
                    height: 40px;
                    background-color: #da006a;
                    color: #fff;
                    border-radius: 20px;

                    &:hover {
                        color: #fff;
                    }
                }

                .share-button {
                    cursor: pointer;
                }

                .misc {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                @media screen and (min-width: 992px) {
                    .profile {
                        margin-top: 0;
                    }

                    .moment .btn-find {
                        position: absolute;
                        bottom: -20px;
                        right: 20px;
                    }

                    .story .btn-find {
                        text-align: right;
                    }

                    .network-icon {
                        margin-right: 0;
                    }

                    .misc {
                        flex-direction: column;
                        align-items: flex-start;
                    }
                }

                .sharing-popup {
                    position: relative;
                    width: 400px;
                    height: 20%;
                    margin-top: -7%;
                    padding-top: 50px;
                    padding-bottom: 20px;
                    text-align: center;
                    background-color: #fff;
                    z-index: 10;
                    border-style: solid;
                    border-color: coral;

                    .close-share {
                        position: absolute;
                        top: 2px;
                        right: 2px;
                        color: #fff;
                        background-color: red;
                        border-radius: 50%;
                        border-color: red;
                        border-style: none;
                    }

                }
            }
        }
</style>